import React, { useState } from "react";
import { motion } from "framer-motion";

const ToggleSwitch = ({ activeTab, setActiveTab } = {}) => {
  return (
    <div
      className="d-flex justify-content-center"
      style={{ width: "300px", margin: "0 auto" }}
    >
      <div className="position-relative d-flex align-items-center bg-light rounded-pill p-1 shadow-sm">
        {/* Sliding Indicator */}
        <motion.div
          className="position-absolute bg-primary rounded-pill"
          style={{ width: "50%", height: "100%" }}
          initial={false}
          animate={{ x: activeTab === "Prebuilt" ? 0 : "100%" }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        />
        {/* Prebuilt Button */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setActiveTab("Prebuilt")}
          className="btn btn-link text-decoration-none flex-fill position-relative"
          style={{
            borderRadius: "50px",
            zIndex: 1,
            color: activeTab === "Prebuilt" ? "#fff" : "#212529",
            fontWeight: 500,
          }}
        >
          Prebuilt
        </motion.button>
        {/* Custom Button */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setActiveTab("Custom")}
          className="btn btn-link text-decoration-none flex-fill position-relative"
          style={{
            borderRadius: "50px",
            zIndex: 1,
            color: activeTab === "Custom" ? "#fff" : "#212529",
            fontWeight: 500,
          }}
        >
          Custom
        </motion.button>
      </div>
    </div>
  );
};

export default ToggleSwitch;
